import { FormHelperText, InputAdornment, OutlinedInput } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { fieldToInputBase } from "formik-mui";
import { useCallback } from "react";

export const CurrencyField = ({
  label,
  margin,
  helperText,
  error,
  ...props
}) => {
  const {
    form: { setFieldValue },
    field: { name },
  } = props;

  const onChange = useCallback(
    (event) => {
      const { value } = event.target;
      setFieldValue(name, value);
    },
    [setFieldValue, name]
  );

  return (
    <FormControl
      fullWidth
      margin={margin}
      sx={{
        label: {
          backgroundColor: "white",
        },
      }}
    >
      <InputLabel htmlFor={`currency-field-${name}`}>{label}</InputLabel>
      <OutlinedInput
        id={`currency-field-${name}`}
        startAdornment={<InputAdornment position="start">£</InputAdornment>}
        fullWidth
        inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
        onChange={onChange}
        // required to map to formik field using formik-mui
        {...fieldToInputBase(props)}
      />
      <FormHelperText htmlFor="outlined-adornment-password" error={error}>
        {helperText}
      </FormHelperText>
    </FormControl>
  );
};
